<div class="auth-wrapper">
  <div class="auth-card">
    <h2>Entrar no CUJU</h2>
    <p class="subtitle">Por favor, insira seus dados para entrar.</p>

    <div class="social-grid">
      <button (click)="onSocialLogin('Google')" class="btn-social google">
        <img src="https://authjs.dev/img/providers/google.svg" alt="Google">
        Google
      </button>
      <button (click)="onSocialLogin('Apple')" class="btn-social apple">
        <img src="https://authjs.dev/img/providers/apple.svg" alt="Apple">
        Apple
      </button>
    </div>

    <div class="divider">
      <span class="divider-text">Ou entre com:</span>
    </div>

    <div class="tab-group"><button type="button" [class.active]="loginMode === 'phone'"
        (click)="setLoginMode('phone')">Número do
        telefone</button>
      <button type="button" [class.active]="loginMode === 'email'" (click)="setLoginMode('email')">E-mail</button>
    </div>

    <form #loginForm="ngForm" (ngSubmit)="onLogin()">

      @if (loginMode === 'email') {
      <div class="form-group">
        <label>E-mail</label>
        <input type="email" name="identifier" [(ngModel)]="credentials.identifier" required email
          placeholder="cuju@mail.com" class="form-control">
      </div>
      } @else {
      <div class="form-group">
        <label>Número do telefone</label>
        <input type="tel" name="identifier" [(ngModel)]="credentials.identifier" required pattern="^\+[1-9]\d{1,14}$"
          placeholder="+55 123 456789" class="form-control">
      </div>
      }

      <div class="form-group">
        <label for="password">Senha</label>
        <input type="password" id="password" name="password" [(ngModel)]="credentials.password" #password="ngModel"
          required class="form-control" [class.error]="password.invalid && password.touched" />
      </div>

      @if (error) {
      <div class="error-banner">
        {{ error }}
      </div>
      }


      <button type="submit" class="btn-login" [disabled]="loginForm.invalid || isLoading">

        @if (!isLoading) {
        <span>Entrar</span>
        } @else {
        <span class="spinner"></span>
        }
      </button>
    </form>
  </div>
</div>